import { render, staticRenderFns } from "./AppointmentsHistory.html?vue&type=template&id=107cca38&external"
import script from "./AppointmentsHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentsHistory.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsHistory.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports